<div (keydown.enter)="locationControl.valid && !isProcessing && !isLoading && save()">
  <h2 mat-dialog-title>{{ title }}</h2>

  <mat-dialog-content>
    <div class="location-select-container">
      @if (isLoading) {
        <div class="loading-overlay">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
      }

      @if (!isLoading) {
        <tc-select-search
          placeholder="Location"
          [ctrl]="locationControl"
          [items]="locationsArray"
          [multiple]="multiple"
          bindValue="location_id"
          bindLabel="name"
          [removable]="true"
        ></tc-select-search>
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button type="button" mat-button (click)="cancel()">
      Cancel
    </button>
    <button
      type="button"
      (click)="save()"
      mat-raised-button
      color="primary"
      [disabled]="locationControl.invalid || isProcessing || isLoading"
    >
      <mat-icon class="fa fa-save"></mat-icon>
      {{ actionTitle }}
    </button>
  </mat-dialog-actions>
</div>